import { useForm } from "react-hook-form";
import styles from "../../../layout/admin/Main.module.scss";
/*共通コンポーネント*/
import SearchCondition from "../../../features/SearchCondition";
import TextField from "../../../ui/TextField";
import CheckboxGroup from "../../../ui/CheckboxGroup";
import Button from "../../../ui/Button";
import Summary from "../../../ui/Summary";
/*バリデーション */
import { validateMaxlength } from "../../../../utils/validate";

const SearchForm = ({ setSearchCondition, authority }) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  //検索条件リセット
  const resetCondition = () => {
    setValue("student_id", "");
    setValue("name", "");
    setValue("name_kana", "");
    //TODO チェックボックス値セット 時間があれば整備
    setValue("is_read_1", false);
    setValue("is_read_0", false);
  };

  const onSubmit = (data) => {
    setSearchCondition(data);
  };

  return (
    <div>
      <details open>
        <Summary />
        <form onSubmit={handleSubmit(onSubmit)}>
          <SearchCondition title="公開者を絞り込む">
            <table>
              <tr>
                <TextField
                  register={register}
                  validation={{ ...validateMaxlength(8) }}
                  name="student_id"
                  errors={errors}
                  label="学生番号(8桁)"
                  placeholder="学生番号(8桁)"
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{ ...validateMaxlength(100) }}
                  name="name"
                  errors={errors}
                  label="氏名"
                  placeholder="氏名"
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{ ...validateMaxlength(100) }}
                  name="name_kana"
                  errors={errors}
                  label="フリガナ"
                  placeholder="フリガナ"
                ></TextField>
              </tr>
              <tr>
                <CheckboxGroup
                  errors={errors}
                  register={register}
                  label="既読状況"
                  name="is_read"
                  elements={[
                    { label: "既読", value: "1" },
                    { label: "未読", value: "0" },
                  ]}
                />
              </tr>
              <div className={styles.buttonbox}>
                <Button type="submit" styleType="search">
                  検索
                </Button>
                <Button
                  type="button"
                  styleType="back"
                  onClick={() => resetCondition()}
                >
                  条件クリア
                </Button>
              </div>
            </table>
            {errors.exampleRequired && <span>This field is required</span>}
          </SearchCondition>
        </form>
      </details>
    </div>
  );
};

export default SearchForm;
